import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/teams.js";

export function useTeams(options = {}) {
  return useQuery({
    queryKey: keys.teams.list,
    queryFn: api.fetchTeams,
    ...options,
  });
}

export function useTeam(id, options = {}) {
  return useQuery({
    queryKey: keys.teams.detail(id),
    queryFn: () => api.fetchTeam(id),
    enabled: !!id,
    ...options,
  });
}

export function useCreateTeam() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createTeam,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.teams.all }),
  });
}

export function useUpdateTeam() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateTeam(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.teams.all }),
  });
}

export function useDeleteTeam() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteTeam,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.teams.all }),
  });
}

export function useAddTeamMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.addTeamMember(id, data),
    onSuccess: (_d, { id }) => {
      qc.invalidateQueries({ queryKey: keys.teams.all });
      qc.invalidateQueries({ queryKey: keys.teams.detail(id) });
    },
  });
}

export function useRemoveTeamMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, userId }) => api.removeTeamMember(id, userId),
    onSuccess: (_d, { id }) => {
      qc.invalidateQueries({ queryKey: keys.teams.all });
      qc.invalidateQueries({ queryKey: keys.teams.detail(id) });
    },
  });
}
